export const SURVEY_QUESTIONS = [
  {
    question_id: 1,
    order: 1,
    question_text: "What was the first product launched by apple?",
    answer: "iPhone",
    totalResponses: 400,
    options: [
      { text: "iPhone", responses: 100 },
      { text: "MAC", responses: 50 },
      { text: "Air Pods", responses: 150 },
      { text: "iPad", responses: 100 },
    ],
  },
  {
    question_id: 2,
    order: 2,
    question_text: "What was the first product launched by google?",
    answer: "Search Engine",
    totalResponses: 100,
    options: [
      { text: "Search Engine", responses: 20 },
      { text: "Phone", responses: 10 },
      { text: "Cloud", responses: 45 },
      { text: "Chrome", responses: 25 },
    ],
  },
  {
    question_id: 3,
    order: 3,
    question_text: "What was the first product launched by microsoft?",
    answer: "Windows",
    totalResponses: 200,
    options: [
      { text: "Azure", responses: 60 },
      { text: "Windows", responses: 40 },
      { text: "Laptop", responses: 20 },
      { text: "Phone", responses: 80 },
    ],
  },
  {
    question_id: 4,
    order: 4,
    question_text: "What was the first product launched by Amazon?",
    answer: "Shopping App",
    totalResponses: 300,
    options: [
      { text: "Shopping App", responses: 56 },
      { text: "AWS", responses: 44 },
      { text: "Prime", responses: 100 },
      { text: "Kindle", responses: 50 },
    ],
  },
  {
    question_id: 5,
    order: 5,
    question_text: "What was the first product launched by Facebook?",
    answer: "Facebook App",
    totalResponses: 500,
    options: [
      { text: "Instagram", responses: 50 },
      { text: "Meta", responses: 50 },
      { text: "Facebook App", responses: 250 },
      { text: "Messanger", responses: 150 },
    ],
  },
];
